module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon5_native.52b33cf1.png";